<div class="py-13 px-12 h-100 border border-gray-100">
    <h6 class="fs-24 fw-700 mb-3 text-secondary font-secondary">{{ store.name }}</h6>

    <div class="mt-3 mb-6">
        <div class="text-secondary font-secondary">{{ store.address }}</div>
        <div>{{ store.postal_code }} {{ store.city }}</div>
        <div>{{ store.country }}</div>
    </div>

    @if (store.open) {
        @if (store.open.everyday) {
            <p class="mb-1">{{ 'PARTNERS.openings_everyday' | translate }}</p>
            <div class="fs-18 font-secondary fw-700">{{ store.open.everyday }}</div>
        } @else {
            @if (store.open.saturday && store.open.week === store.open.saturday) {
                <p class="mb-1">{{ 'PARTNERS.openings_with_saturday' | translate }}</p>
                <div class="fs-18 font-secondary fw-700">{{ store.open.week }}</div>
            }
            @if (store.open.saturday && store.open.week !== store.open.saturday) {
                <p>{{ 'PARTNERS.openings_week' | translate }}</p>
                <div class="fs-18 font-secondary fw-700">{{ store.open.week }}</div>
                <p>{{ 'PARTNERS.openings_saturday' | translate }}</p>
                <div class="fs-18 font-secondary fw-700">{{ store.open.saturday }}</div>
            }
            @if (!store.open.saturday && store.open.week) {
                <p class="mb-1">{{ 'PARTNERS.openings_week' | translate }}</p>
                <div class="fs-18 font-secondary fw-700">{{ store.open.week }}</div>
            }
            @if (store.open.sunday) {
                <p class="mt-4 mb-2">{{ 'PARTNERS.openings_sunday' | translate }}</p>
                <div class="fs-18 font-secondary fw-700">{{ store.open.sunday }}</div>
            }
        }
    }
    @if (store.note) {
        <p class="mt-2 mb-0 fst-italic">{{ store.note | translate }}</p>
    }
    @if (store.phones) {
        <div class="mt-4">
            <p class="mb-1">{{ 'PARTNERS.phone' | translate }}</p>
            @for (phone of store.phones; track phone) {
                <div class="d-block">
                    <a class="fs-18 font-secondary fw-700 text-secondary" href="tel:{{ phone }}">{{ phone }}</a>
                </div>
            }
        </div>
    }
    @if (store.emails) {
        <div class="mt-4">
            <p class="mb-1">{{ 'PARTNERS.email' | translate }}</p>
            @for (email of store.emails; track email) {
                <div class="d-block">
                    <a class="fs-18 font-secondary fw-700 text-secondary" href="mailto:{{ email }}" [innerHtml]="email"></a>
                </div>
            }
        </div>
    }
    @if (store.links) {
        <div class="mt-4">
            <p class="mb-1">{{ 'PARTNERS.links' | translate }}</p>
            @for (link of store.links; track link) {
                <div class="d-block">
                    <a class="fs-18 font-secondary fw-700 text-secondary" [href]="link.url">{{ link.name ? (link.name | translate) : link.url }}</a>
                </div>
            }
        </div>
    }
</div>
